// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-96ba9830].ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper {\n  width: 52px !important;\n  margin-bottom: 10px;\n  margin-right: 9px !important;\n}\n.pro .tips[data-v-96ba9830] {\n  height: 50px;\n  line-height: 50px;\n  color: #999;\n  font-size: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.btn-box[data-v-96ba9830] {\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
